import { render, staticRenderFns } from "./FacebookAdsTableHeader.vue?vue&type=template&id=5c46166c&"
import script from "./FacebookAdsTableHeader.vue?vue&type=script&lang=js&"
export * from "./FacebookAdsTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports